import { api } from '../config'

export const INFO_SECTION_URL = {
  get_info_sections: `${api.withAPI}administrative/api/v1/admin/sectionInfo`,
  updateInfoSection: (id: string) =>
    `${api.withAPI}administrative/api/v1/admin/sectionInfo/${id}`,
}
